// extracted by mini-css-extract-plugin
module.exports = {"quiz-tab-item":"quiz-tab-item_quiz-tab-item__XkqVs","quiz-tab-item--focus-visible":"quiz-tab-item_quiz-tab-item--focus-visible__BLgv_"};